const STATUS_CLASSES = {
  "Best Seller": "border-[#6D28D9]/60 bg-[#6D28D9]/10 text-[#6D28D9]",
  Trending: "border-emerald-600/40 bg-emerald-600/[0.06] text-emerald-700",
  Exclusive: "border-fuchsia-600/40 bg-fuchsia-600/[0.06] text-fuchsia-700",
  "Pre IPO": "border-sky-600/40 bg-sky-600/[0.06] text-sky-700",
  Active: "border-slate-300 text-slate-500",
  "High Demand": "border-[#6D28D9]/60 bg-[#6D28D9]/10 text-[#6D28D9]",
  Watchlist: "border-rose-600/40 text-rose-700",
};

export const statusClass = (status) => STATUS_CLASSES[status] || STATUS_CLASSES.Active;
